// filepath: apps/web/src/features/admin/templates/registry/InstallButton.tsx
//
// FR-UI-ADM-11 AC-4 -- per-row install action. Submits the install
// verb via the parent page's useTemplateInstall hook. The button
// is disabled while the install is in flight; the parent page
// surfaces typed error cards for the failure states.

import React from "react";
import { useTranslation } from "@/i18n/useTranslation";
import type { TemplateRegistryRow } from "./types";

interface InstallButtonProps {
  row: TemplateRegistryRow;
  onInstall: (row: TemplateRegistryRow) => void;
  isInstalling: boolean;
}

export function InstallButton({
  row,
  onInstall,
  isInstalling,
}: InstallButtonProps): React.ReactElement {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      disabled={isInstalling}
      onClick={() => onInstall(row)}
      className="rounded bg-primary px-3 py-2 text-xs font-medium text-primary-foreground hover:bg-primary/90 disabled:cursor-not-allowed disabled:opacity-50"
      data-testid="template-registry-row-install"
      aria-label={t("admin.templates.registry.action.install_aria", undefined, {
        template_id: row.template_id,
        version: row.version,
      })}
      style={{ minHeight: "48px", minWidth: "48px" }}
    >
      {isInstalling
        ? t("admin.templates.registry.action.installing")
        : t("admin.templates.registry.action.install")}
    </button>
  );
}
